import React from 'react'
import PropTypes from 'prop-types'
import Tab from './Tab'

function TabsList ({ tabs, tabNameSelected, onClick }) {
    return tabs.map(({ name, href }) => (
        <Tab key={name} name={name} href={href} selected={tabNameSelected === name} />)
    )
}

TabsList.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
        }),
    ),
    tabNameSelected: PropTypes.string,
    onClick: PropTypes.func,
}

export default TabsList
